import { Badge, Flex, Text } from '@/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const CommentUnreadBadge: FC = () => {
  const { t } = useTranslation();
  return (
    <Flex align="center">
      <Badge color="blue" />
      <Text
        style={{ marginLeft: 4 }}
        weight="regular"
        variant="footnote"
        text={t('comment.unread')}
      />
    </Flex>
  );
};
